import { render, staticRenderFns } from "./BriefContentPanel.vue?vue&type=template&id=7ab796d6&scoped=true"
import script from "./BriefContentPanel.vue?vue&type=script&lang=js"
export * from "./BriefContentPanel.vue?vue&type=script&lang=js"
import style0 from "./BriefContentPanel.vue?vue&type=style&index=0&id=7ab796d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab796d6",
  null
  
)

export default component.exports